export const LOCATION_TYPE = ['administrative', 'city', 'postcode', 'town', 'postal_code'];
